import { useEffect, useState } from 'react'

import { useAccount } from 'wagmi'

import { EVMAddress } from '@src/types/token'
import { createContextLogger } from '@src/utils'

const logger = createContextLogger('useEVMWallet')

export const useEVMWallet = () => {
    const [isEVMConnected, setIsEVMConnected] = useState<boolean>(false)
    const [EVMChainId, setEVMChainId] = useState<number | undefined>(undefined)
    const [evmWalletAddress, setEvmWalletAddress] = useState<EVMAddress | undefined>(undefined)

    const { address: evmAddress, chainId: evmChainId, isConnected: evmWalletConnected, connector } = useAccount()

    useEffect(() => {
        if (evmWalletConnected && evmAddress) {
            !isEVMConnected && setIsEVMConnected(true)
            EVMChainId !== evmChainId && setEVMChainId(evmChainId)
            evmWalletAddress !== evmAddress && setEvmWalletAddress(evmAddress as EVMAddress)
        } else {
            setIsEVMConnected(false)
            setEVMChainId(undefined)
            setEvmWalletAddress(undefined)
        }
    }, [evmWalletConnected, evmAddress])

    return {
        isEVMConnected,
        EVMChainId,
        evmWalletAddress,
    }
}
